export default {
    monitor: {name: "监视器"},
    keyboard: {name: "键盘"},
    mouse: {name: "老鼠"},
    webcam: {name: "摄像头"},
    headset: {name: "耳机"},
    dockingStation: {name: "扩展坞"},
}